import React from "react";

const CustomTextarea = ({
  title,
  errors,
  setFieldValue,
  handleBlur,
  values,
  fieldName = 'description',
  touched,
  submitCount
}) => {
  const showError = (touched && touched[fieldName]) || (submitCount && submitCount > 0);
  const hasError = errors && errors[fieldName];

  return (
    <div
      className={`form-group col-md-12 mb-3 ${showError && hasError ? "is-invalid" : ""
        }`}
    >
      <label className="text-label">{title ?? "Description"}</label>
      <textarea
        onChange={(e) => {
          let value = e.target.value;
          const wordCount = value.trim().split(/\s+/).length;
          if (wordCount < 200) {
            setFieldValue(fieldName, value);
          } else {
            // Allow only if editing existing content (like backspace) or modifying within 200 words
            const lastChar = value.slice(-1);
            if (lastChar !== " " && value.trim().split(/\s+/).length <= 200) {
              setFieldValue(fieldName, value);
            }
          }
        }}
        onBlur={handleBlur}
        value={values[fieldName]}
        className="form-control"
        rows="6"
        name={fieldName}
        style={{ resize: "none" }}
      />
      {(showError && hasError) ? (
        <div
          id="val-description-error"
          class="invalid-feedback animated fadeInUp"
          style={{ display: "block" }}
        >
          {errors[fieldName]}
        </div>
      ) : null}
    </div>
  );
};

export default CustomTextarea;
